import Vue from 'vue'
import Vuex from 'vuex'
import http from "@/utils/http";

Vue.use(Vuex)

const store = new Vuex.Store({
    state: {
        // 商品弹窗场控
        explain_type:"",//弹窗类型
        explainIndex:0,//弹窗索引
        explainKeyword:false,//是否优先关键词讲解
        explainKeywordShow:false,//是否优先关键词讲解

        // 回复场控
        replyIndex:0,//回复索引
        replyStatus:false,//关键词回复开关
        replyAiStatus:false,//AI自动回复开关
    //    文字场控
        textStatus:false,
        textIndex:0,

        //     贴片
        stickyStatus: false,//置顶贴片开关
        stickyIndex: 0,//置顶贴片索引

        // ai语音


        isAIEnabled: false,
        isAIReplyEnabled: false,



        // 音频播放器
        anchorAudio: null,
        keywordAudio: null,
        timingAudio: null,
        welcomeAudio: null,
        fragmentsAudio: null,

        // 音频控制
        modules: null,
        voicesConfig: null,
        configVoice:null,
        channelConfig:{
            inputDeviceId:'default',
            outputDeviceId: 'default',
            dodgeEnabled:true,
        },

        liveWs:null,
        liveUrl:null,

        liveData:{
            userCount:0,
            messageData:{
                nickname:"",
                content:"",
            },
            room_nickname:"",
        },

        goodsKeyword:"",
        textKeyword:"",



        liveKeyword:"",




        // 用户信息

        userInfo:null,
        appids:null,

        //AI替你播

        apiKey:null,
        referenceText: "",//参考话术内容
        productInfo: "",//主播信息
        aiPlayStatus:false,
        messageList:[],

        insertAudioList:[],

        ttsStatus:false,

        userReception:{
            // 进入欢迎
            enterWelcome:false,
            // 进入欢迎时间间隔
            enterWelcomeInterval:60,
            // 公屏回复开关
            publicReply:false,
            // 公屏回复时间间隔
            publicReplyInterval:60,
            // 用助播回复
            useAnchorReply:false,
        },





    },
    mutations: {

        setFragmentsAudio(state,data){

            state.fragmentsAudio=data;
        },

        setTtsStatus(state,data){

            state.ttsStatus=data;


        },

        setInsertAudioList(state,data){

            state.insertAudioList=data;
        },
        setTextKeyword(state,data){
            state.textKeyword=data;
        },
        setLiveKeyword(state,data){
            state.liveKeyword=data;
        },

        setGoodsKeyword(state,data){
            state.goodsKeyword=data;
        },


        setLiveData(state,data){
          state.liveData[data.type]=data.data;
        },

        setliveWs(state,data){

            state.liveWs=data;

        },

        setliveUrl(state,data){
            state.liveUrl=data;
        },
        setUserReception(state,data){
            state.userReception=data;
        },


        setProductInfo(state,data){
            state.productInfo=data;
        },

        setMessageList(state,data){
            state.messageList=data;
        },

        // ai替你播
        setAiPlayStatus(state,status){
            state.aiPlayStatus=status;
        },



        // 设置api接口id
        setAppids(state,data){
            state.appids=data;
        },

        setApiKey(state,data){
            state.apiKey=data;
        },

        setUserInfo(state,data){
            state.userInfo=data;
        },

        setChannelConfig(state,data){
            state.channelConfig=data;
        },

        setConfigVoice(state,data){
            state.configVoice=data;
        },

        setVoicesConfig(state,data){
            state.voicesConfig = data;
        },


        setModules(state,data){
            state.modules=data;
        },

        setAudios(state,audio){
            state.anchorAudio=audio.anchorAudio;
            state.keywordAudio=audio.keywordAudio;
            state.timingAudio=audio.timingAudio;
            state.welcomeAudio=audio.welcomeAudio;
        },


        // Ai替你播
        setReferenceText(state,text){
            state.referenceText=text;
        },


        // ai语音控制

        setAIEnabled(state,status){
            state.isAIEnabled = status;
        },
        setAIReplyEnabled(state,status){
            state.isAIReplyEnabled = status;
        },



        // 回复控制
        setReplyAiStatus(state,status){
          state.replyAiStatus=status;
        },
        setReplyStatus(state,status){
            state.replyStatus = status;
        },
        setReplyIndex(state,index){
            state.replyIndex = index;
        },

        // 商品弹窗控制
        setExplainKeyword(state,status){
            state.explainKeyword = status;
        },
        setExplainKeywordShow(state,status){
            state.explainKeywordShow = status;
        },
        setExplainIndex(state, index) {
            state.explainIndex = index;
        },
        setExplainType(state, type) {
            state.explain_type = type;
        },

        // 文字控制
        setTextStatus(state,status){
            state.textStatus = status;
        },
        setTextIndex(state,index){
            state.textIndex = index;
        },
        // 贴片控制
        setStickyStatus(state,status){
            state.stickyStatus = status;
        },
        setStickyIndex(state,index){
            state.stickyIndex = index;
        },

    },
    actions: {},
    getters: {}
})




export default  store



